export type Feature = 'startAnyStep' | 'use-global-recs';

// Example: http://url.com?feature=foo&feature=bar
// isFeatureEnabled('foo') => true
// isFeatureEnabled('bar') => true
// isFeatureEnabled('baz') => false
export const isFeatureEnabled = (featureName: Feature) => {
  const search = typeof window !== 'undefined' ? location.search : '';
  const searchParams = new URLSearchParams(search);
  const features = searchParams.getAll('feature') || [];

  if (typeof features === 'string') {
    return featureName === features;
  }

  return features.some((feature: string | null) => feature === featureName);
};

export default isFeatureEnabled;
